


















import { mdiCloseCircle, mdiCheckboxMarkedCircle } from '@mdi/js';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { StatementsJointModule } from '@/store/modules/statementsJoint';
// eslint-disable-next-line no-unused-vars
import { IStatementShortInfo } from '@/utils/types';
import StatementsList from '@/components/elements/statement/StatementsList.vue';

@Component({
  components: { StatementsList },
  data() {
    return {
      mdiCloseCircle,
      mdiCheckboxMarkedCircle,
    };
  },
})
export default class StatementsJointTable extends Vue {
  @Prop(Number) limit?: number;
  @Prop(Boolean) paginationShow?: boolean;
  @Prop({ type: String, default: 'Нет данных' }) notDataText?: string;

  private dataTable: IStatementShortInfo[] = [];
  loading: boolean = false;
  private allCount: number | null = null;
  private currentPage: number = 1;
  private pageSize: number = 15;

  async mounted() {
    StatementsJointModule.changePageSize(this.pageSize);
    StatementsJointModule.changePageNumber(this.currentPage - 1);
    await this.getData();
  }

  async getData() {
    this.loading = true;
    if (this.limit) {
      await StatementsJointModule.changePageSize(this.limit);
    }
    await StatementsJointModule.loadUserAddSigStatements();
    this.allCount = StatementsJointModule.totalCount;
    this.dataTable = StatementsJointModule.list;
    this.loading = false;
  }

  async onChangePage(val: number) {
    this.currentPage = val;
    await StatementsJointModule.changePageNumber(val - 1);
    await this.getData();
  }

  async onChangeLimit(val: number) {
    this.loading = true;
    this.currentPage = 1;
    this.pageSize = val;
    await StatementsJointModule.changePageNumber(0);
    await StatementsJointModule.changePageSize(val);
    await StatementsJointModule.loadUserAddSigStatements();
    this.dataTable = StatementsJointModule.list;
    this.allCount = StatementsJointModule.totalCount;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  go(id: string) {
    this.$router.push({ name: 'StatementDetail', params: { id: id } });
  }
}
